module.exports = {"resourceQuery":null,"query":"?query","prev":"xyz: abc"}


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/context/loaders/queryloader.js?query!./resolving/context/~/subcontent/test.jade
 ** module id = 4
 ** module chunks = 0
 **/